import * as DocumentationConstant from "../Constants/DocumentationConstant";
import { DocumentationType, MdFileExtension, XmlFileExtension, YmlFileExtension } from "../Constants/DocumentationConstant";
import { findDocumentationPathInMenu } from "./SideBarUtils";
import * as StringUtils from "./StringUtils";

import $ from "jquery";
import validUrl from "valid-url";

export { DocumentationType, MdFileExtension, XmlFileExtension, YmlFileExtension }

const MenuPathSeparator = " > ";
const AddedRef = "addedref:";

const getFileExtension = (filePath) => {
    let foundExtension = null;
    if (filePath && typeof filePath === "string") {
        const matchExtensions = filePath.match(/\.\w+$/);
        if (matchExtensions && matchExtensions.length > 0) {
            foundExtension = matchExtensions[0].substr(1);
        }
    }
    return foundExtension;
}

const hasFileExtension = (filePath, extension) => {
    let hasExtension = false;
    const fileExtension = getFileExtension(filePath);
    if (fileExtension && (extension === fileExtension || extension === "." + fileExtension)) {
        hasExtension = true;
    }
    return hasExtension;
}

const removeFileExtension = (filePath) => {
    let newFilePath = filePath;
    const fileExtension = getFileExtension(filePath);
    if (filePath && fileExtension) {
        const extensionRegex = new RegExp("." + fileExtension + "$", "i");
        newFilePath = filePath.replace(extensionRegex, "");//remove md extension
    }
    return newFilePath;
}

export const isMarkdownFile = (filename) => {
    return hasFileExtension(filename, DocumentationConstant.MdFileExtension)
}

export const isWithoutFileExtension = (filename) => {
    const fileExt = getFileExtension(filename);

    if (fileExt) {
        if (isCSharpSdkDocWithoutFileExtension(filename)) {//case for csharp doc
            return true;
        } else {
            return false;
        }
    }
    return true;
}

export const isHtmlFile = (filename) => {
    return hasFileExtension(filename, DocumentationConstant.HtmlFileExtension)
}

export const isSwaggerFile = (filename) => {
    const foundExtension = filename.match(/\/swagger$/);
    return foundExtension != null;
}

export const isCSharpSdkDoc = (filename) => {
    let isCSharpDoc = filename.match(/^\/doc\/sdk\/csharp\/(common|core|wpf|webrtc)\/.*/);
    return isCSharpDoc != null;
}

export const isCSharpSdkDocWithoutFileExtension = (filename) => {
    const isCSharpDoc = isCSharpSdkDoc(filename);
    const extension = getFileExtension(filename);
    let foundExtension = DocumentationConstant.fileExtensionsList.some(item => item === "." + extension);
    return isCSharpDoc && !foundExtension;
}

export const getPrettyTitleFromPath = (pathname) => {
    let menuPath = pathname.replace(/\.\w+$/, "");//remove extension
    menuPath = menuPath.replace("/doc/sdk/", "");//remove start (sdk doc)
    menuPath = menuPath.replace("/doc/", "");//remove start (other doc)
    menuPath = menuPath.replace(/\//g, MenuPathSeparator);//replace / by >
    menuPath = StringUtils.capitalizeFirstLetter(menuPath);

    return menuPath;
}

export const isDocumentationPath = (pathname) => {
    if (pathname && pathname.startsWith(DocumentationConstant.DOC_PATH)) {
        return true;
    }
    return false;
}

export const isStsDocumentation = (pathname) => {
    if (pathname && pathname.indexOf("/" + DocumentationConstant.DocumentationType.Sts + "/") > 0) {
        return true;
    }
    return false;
}

export const isLtsDocumentation = (pathname) => {
    if (pathname && pathname.indexOf("/" + DocumentationConstant.DocumentationType.Lts + "/") > 0) {
        return true;
    }
    return false;
}

export const getDocumentMenuPath = (documentationPath, removeExtension) => {
    let menuPath = "";

    let pathName = documentationPath
    if (removeExtension) {
        pathName = removeFileExtension(pathName);
    }

    const sideBarParentElements = findDocumentationPathInMenu(pathName);
    sideBarParentElements.each(function (i) {
        const firstChild = $(this).children("a:first-child");
        if (firstChild.length > 0) {
            const separator = i === 0 ? "" : MenuPathSeparator;
            menuPath = $(this).children("a:first-child").children("span:first-of-type").text() + separator + menuPath;
        }
    });

    return menuPath;
}

export const getVersionFileUrl = (indexFileUrl) => {
    let versionFilePath = "";
    if (indexFileUrl && indexFileUrl.length > 0) {
        let splittedPath = indexFileUrl.split("/").slice(0, -1);
        splittedPath.push(DocumentationConstant.DocumentationVersionFile);
        versionFilePath = splittedPath.join("/");
    }
    return versionFilePath;
}

const convertToUri = (filePath) => {
    let uri = validUrl.isUri(encodeURI(filePath));
    if (!uri) {
        uri = validUrl.isUri(AddedRef + encodeURI(filePath));
    }
    return uri;
}

export const addBetaToUri = (uri) => {
    return uri + "?" + DocumentationConstant.DocumentationBetaTagName;
}

export const removeSearchParamsFromUri = (uri) => {
    let splittedUri = uri
    if (uri) {
        splittedUri = uri.split("?")[0];
    }
    return splittedUri;
}

export const hasBetaInUri = (searchUri) => {
    let hasBeta = false;
    // const convertedUri = convertToUri(uri);
    if (searchUri) {
        const searchParam = new URLSearchParams(searchUri);
        hasBeta = searchParam.has(DocumentationConstant.DocumentationBetaTagName);
    }
    return hasBeta;
}

export const hasFileExtensionInUri = (uri, extension) => {
    let hasSameExtension = false;
    const convertedUri = convertToUri(uri);
    if (convertedUri) {
        const url = new URL(convertedUri);
        hasSameExtension = hasFileExtension(url.pathname, extension)
    }
    return hasSameExtension;
}

export const removeProtocolAndFileExtensionFromUri = (uri, removeExtension = false) => {
    let url = uri;
    const convertedUri = convertToUri(uri);
    if (convertedUri) {
        let modifiedUrl = new URL(convertedUri);
        url = modifiedUrl.pathname + modifiedUrl.search;
        if (removeExtension) {
            url = removeFileExtension(modifiedUrl.pathname) + modifiedUrl.search;
        }
    }
    return url;
}
